import { AutogenModelEdiBatchHistory, AutogenRowEdiBatchHistory } from "./autogen/AutogenModelEdiBatchHistory";

export class ModelEdiBatchHistory extends AutogenModelEdiBatchHistory<RowEdiBatchHistory> {
	constructor() {
		super(RowEdiBatchHistory);
	}
}

export class RowEdiBatchHistory extends AutogenRowEdiBatchHistory {
}